export default [
    {
        path: '/blogs',
        name: 'blogs',
        component: () => import('VIEWS/Blogs.vue')
    },
    {
        path: '/blogs/:id',
        name: 'blog-post',
        component: () => import('VIEWS/BlogPost.vue')
    }
]
